import { defineMessages } from "react-intl";

export default defineMessages({
  scriptPlaceholder: {
    id: "containers.SupplierSyntheticVoicePage.scriptPlaceholder",
    defaultMessage: "Enter your script here (max 200 characters)",
  },
  legalNotice: {
    id: "containers.SupplierSyntheticVoicePage.legalNotice",
    defaultMessage:
      "For non-commercial demonstrations purposes use only. Any use outside VoiceArchive website is currently prohibited, and violates our <tcs>terms and conditions</tcs>.",
  },
  processing: {
    id: "containers.SupplierSyntheticVoicePage.processing",
    defaultMessage: "Processing...",
  },
  generateVoice: {
    id: "containers.SupplierSyntheticVoicePage.generateVoice",
    defaultMessage: "Generate",
  },
  approveVoice: {
    id: "containers.SupplierSyntheticVoicePage.approveVoice",
    defaultMessage: "Approve",
  },
  scriptFlagged: {
    id: "containers.SupplierSyntheticVoicePage.flagged",
    defaultMessage:
      "Your script has been flagged for moderation. Please try again.",
  },
  scriptProfanity: {
    id: "containers.SupplierSyntheticVoicePage.profanity",
    defaultMessage: "Your script contains profanity. Please try again.",
  },
});
